import { ProjectItemOption } from './../../../sdk/models/project-item-option';
import { ProjectItemOptionControllerService } from './../../../sdk/services/project-item-option-controller.service';
import { VendorInfoControllerService } from './../../../sdk/services/vendor-info-controller.service';
import { VendorInfoOptionControllerService } from './../../../sdk/services/vendor-info-option-controller.service';
import { VendorInfoOption } from './../../../sdk/models/vendor-info-option';
import { AssignEngineerControllerService } from './../../../sdk/services/assign-engineer-controller.service';
import { ProjectItemControllerService } from './../../../sdk/services/project-item-controller.service';
import { FormHead } from './../../../sdk/models/form-head';
import { FormApplyDetailControllerService } from './../../../sdk/services/form-apply-detail-controller.service';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AreaBuilding, AssignEngineer, FormApplyDetail, FormSignProcess, ProjectItem, VendorInfo } from 'src/app/sdk/models';
import { AppointmentManufacturerTimeControllerService, AreabuildingControllerService, BaseHolidayControllerService, BaseMaterialListControllerService, BidItemControllerService, BidItemDetailControllerService, FormBudgetChargeControllerService, FormheadControllerService, FormQuotationControllerService, FormSignProcessControllerService } from 'src/app/sdk/services';
type service =
  | AreabuildingControllerService
  | FormSignProcessControllerService
  | FormApplyDetailControllerService
  | FormheadControllerService
  | ProjectItemControllerService
  | AssignEngineerControllerService
  | VendorInfoOptionControllerService
  | VendorInfoControllerService
  | ProjectItemOptionControllerService
  | BaseHolidayControllerService

type RawModel =
  | AreaBuilding
  | FormSignProcess
  | FormApplyDetail
  | FormHead
  | ProjectItem
  | AssignEngineer
  | VendorInfoOption
  | VendorInfo
  | ProjectItemOption

interface FindFilter {
  where?: { [key: string]: any };
  limit?: number;
  order?: string;
  fields?: { [key: string]: any };
  include?: { [key: string]: any };
}
@Injectable({
  providedIn: 'root',
})
export class Lb4ApiService {
  constructor(
    private http: HttpClient,
    private areabuildingControllerService: AreabuildingControllerService,
    private formSignProcessService: FormSignProcessControllerService,
    private formApplyDetailService: FormApplyDetailControllerService,
    private formheadService: FormheadControllerService,
    private projectItemService: ProjectItemControllerService,
    private assignEngineerService: AssignEngineerControllerService,
    private vendorInfoOptionService: VendorInfoOptionControllerService,
    private vendorInfoService: VendorInfoControllerService,
    private projectItemOptionService: ProjectItemOptionControllerService,
    private appointmentManufacturerTimeControllerService: AppointmentManufacturerTimeControllerService,
    private bidItemDetailControllerService: BidItemDetailControllerService,
    private bidItemControllerService: BidItemControllerService,
    private formBudgetChargeControllerService: FormBudgetChargeControllerService,
    private formQuotationControllerService: FormQuotationControllerService,
    private baseMaterialListControllerService: BaseMaterialListControllerService,
    private baseHolidayControllerService: BaseHolidayControllerService
  ) { }
  services: { [key: string]: service } = {
    area_building: this.areabuildingControllerService,
    form_sign_process: this.formSignProcessService,
    form_apply_detail: this.formApplyDetailService,
    form_head: this.formheadService,
    project_item: this.projectItemService,
    assign_engineer: this.assignEngineerService,
    vendor_info_option: this.vendorInfoOptionService,
    vendor_info: this.vendorInfoService,
    project_item_option: this.projectItemOptionService,
    appointment_manufacturer_time: this.appointmentManufacturerTimeControllerService,
    bid_item_detail: this.bidItemDetailControllerService,
    bid_item: this.bidItemControllerService,
    form_budget_charge: this.formBudgetChargeControllerService,
    form_quotation: this.formQuotationControllerService,
    base_material_list: this.baseMaterialListControllerService,
    base_holiday: this.baseHolidayControllerService
  };
  _configUrl: string = '';
  uploadLinks: [string, string][] = [
    ['area_building', 'base-tares/batchUploadData'],
  ];
  uploadLinkMaps = new Map<string, string>(this.uploadLinks);
  get configUrl(): string {
    return this._configUrl;
  }
  set configUrl(configurl: string) {
    this._configUrl = configurl;
  }
  async getLoopBackApi() {
    const config = this.http
      .get<{ LoopBackApi: string }>('./../../../../assets/config/config.json')
      .toPromise();
    const res = await config;
    return res.LoopBackApi;
  }

  find<T>(model: string, filter: FindFilter): Promise<RawModel[]> {
    return this.services[model]
      .find({ filter: JSON.stringify(filter) })
      .toPromise();
  }

  create(model: string, body: any) {
    return this.services[model].create({ body }).toPromise();
  }

  updateById(model: string, body: any, id: number) {
    return this.services[model].updateById({ id, body }).toPromise();
  }

  deleteById(model: string, id: number) {
    return this.services[model].deleteById({ id }).toPromise();
  }

  createOrUpdate(model: string, body: any) {
    if (body.id) return this.updateById(model, body, body.id);
    else return this.create(model, body);
  }

  updateAll(model: string, body: any, where: any) {
    return this.services[model]
      .updateAll({ where: JSON.stringify(where), body })
      .toPromise();
  }

  batchUploadData(model: string, body: FormData, type?: string) {
    const url = type
      ? `${this.configUrl}/${this.uploadLinkMaps.get(model)}?type=${type}`
      : `${this.configUrl}/${this.uploadLinkMaps.get(model)}`;
    return this.http.post(url, body);
  }
}
